/**
 * Previously ran proactive refresh against a refresh token. Access-token-only sessions
 * do not refresh; expiry is handled when attaching Authorization or on 401.
 */
export const startTokenExpiryChecker = () => () => {};
